import styled from 'styled-components';

import Icon from 'components/Icon';

const Container = styled.div`
	background-color: white;
	box-shadow: 0 2px 3px 0 rgba(0,0,0,0.2);
	border-radius: 2px;
	padding: 24px;
	width: 600px;
	min-width: 600px;
	max-width: 50vw;
	max-height: calc(90vh - 100px);
	overflow-y: auto;
	position: relative;
`;

const Heading = styled.h2`
	font-weight: bold;
	margin: 0 0 16px;
	display: flex;
	align-items: center;

	button {
		margin-left: 1rem;
		border: 1px solid rgb(160,160,160);
		color: rgb(160,160,160);
    padding: 4px 8px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s ease-out;

		&:hover {
			padding: 4px 12px;
			border: 1px solid rgb(74, 144, 226);
			color: rgb(74, 144, 226);
		}
	}
`;

const Recipients = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

const Column = styled.div`
	flex-basis: 40%;
	margin: 0 16px 8px 0;
`;

const Label = styled.label`
	color: #787878;
	font-size: 16px;
`;

const Input = styled.input`
	padding-left: 0px;
	border-radius: 4px;
	height: 32px;
	background-color: ${props => props.error ? 'rgba(255,210,230,1)' : 'rgba(240,240,240,1)'};
	width: 100%;
	border: 0;
	font-size: 18px;
	padding: 0 8px;
	margin: 0
`;

const Controls = styled.div`
	height: 24px;
	flex-basis: calc(20% - 32px);
	display: flex;
	justify-content: space-evenly;
	align-items: center;
`;

const New = styled.div`
	flex-basis: 100%;
	color: #787878;
	font-size: 14px;
	height: 24px;
	display: inline-flex;
	align-items: center;
	cursor: pointer;
	margin: 16px 0 32px;

	&:hover,
	&:active {
		color: #4A90E2;

		svg {
			fill: #4A90E2;
		}
	}
`;

const AddIcon = styled(Icon)`
	margin-right: 8px;

	svg {
		fill: #787878;
	}
`;

const Textarea = styled.textarea`
	max-width: 100%;
	min-width: 100%;
	width: 100%;
	height: 200px;
	background-color: #EBEBEB;
	border-radius: 4px;
	padding: 24px;
	color: #001D4F;
	border: 0;
	outline: none;
	margin: 8px 0 24px;
	font-size: 18px;
`;

const Actions = styled.div`
	display: flex;
	justify-content: space-between;

	button {
		min-width: 40%;
	}
`;

const InlineAction = styled.button`
	background-color: rgba(0,0,0,0);
	border: 0;
	font-size: 16px;
	color: #001D4F;
	text-decoration: underline;
	margin-bottom: 16px;
	cursor: pointer;

	&:nth-last-child(1) {
		margin-bottom: 0px;
	}
`;

const Link = styled.a`
	color: #787878;
	margin: 40px 0;
	display: flex;
	align-items: center;
	font-size: 16px;

	span {
		margin-right: 8px;
	}
`;

export {
	Container,
	Heading,
	Recipients,
	Column,
	Label,
	Controls,
	Input,
	New,
	AddIcon,
	Textarea,
	Actions,
	InlineAction,
	Link,
}
